<template>
  <div class="OwnerAppadvertisingList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="village" :disabled="showAllGarden === 1" :placeholder="$t('lang.villageall')">
            <el-option key :label="$t('lang.villageall')" :value="0"></el-option>
            <el-option v-for="item in tableData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="keyword" :placeholder="detail.sloganName"></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>

      </el-form>
    </div>
    <el-card>
      <el-button slot="header" size="medium" type="primary" @click="jumpToAdd">
        {{detail.addSlogan}}</el-button>
      <el-table :data="advertisingList" :height="advertisingList.length > 0 ? require('@/config/enum').tableheight530 : require('@/config/enum').tableheight109" class="wid100" :row-class-name="tableRowClassName">
        <el-table-column type="selection" width="55" v-if="this.acheckbox"></el-table-column>
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column prop="gardenName" :label="$t('lang.lab_OwnerVillageall')" width="150">
        </el-table-column>
        <el-table-column prop="categoryName" :label="$t('lang.lab_OwnerFl')" width="150">
        </el-table-column>
        <el-table-column prop="secCategoryName" :label="$t('lang.lab_typeName2')" width="150">
        </el-table-column>
        <el-table-column prop="name" :label="$t('lang.lab_OwnerName')">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light" v-if="scope.row.name&&scope.row.name.length>10"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.name }}
                </span>
              </div>
              <div>
                {{ scope.row.name.substring(0, 10) | valueIsNull }}
                <span v-if="scope.row.name.length>10">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.name | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="beginTime" :label="$t('lang.lab_OwnerBeginDate')" width="150">
          <template slot-scope="scope">
            {{ scope.row.beginTime | time }}
          </template>
        </el-table-column>
        <el-table-column sortable prop="endTime" :label="$t('lang.lab_OwnerEndDate')" width="150">
          <template slot-scope="scope">
            {{ scope.row.endTime | time }}
          </template>
        </el-table-column>
        <el-table-column prop="orderBy" :label="$t('lang.lab_OwnerSort')" width="150">
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteItem(scope.row)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>
<script>
  /**
   *@ClassName:OwnerAppadvertisingList
   *@Description:业主端App广告管理
   *@author:邹恒志
   *@Copyright:格众科技
   *@date:2020-02-20
   */
  export default {
    name:'/manage/main.doorDeviceNoticeList',
    data() {
      return {
        village: this.$store.getters.gardenId,
        showAllGarden: this.$store.getters.gardenId != 0 ? 1 : 0,
        pageCount: 0, // 总数
        pageNum: 1, // 页数
        pageSize: 10, // 每页显示数量
        keyword: '', // 保存输入的查询词
        detail: this.$i18n.t('lang.ownerApp'),
        ruleForm: {
          housing: '',
          region: '',
          Appname: '',
        },
        advertisingList: [], // 业主App广告管理数据列表
        tableData: [], // 所有小区存储
        acheckbox: require('@/config/enum').acheckbox, // 是否隐藏复选框
        deletename: require('@/config/enum').deletename
      }
    },
    created() {
      setTimeout(() => {
         window.localStorage.setItem('yzappform', '')
         window.localStorage.setItem('yzappsaveData', '')
      }, 200)
      this.gardens()
      this.topics()
    },
    activated(){
      this.gardens()
      this.topics()
    },
    watch: {
      village: function (newFlag, oldFlag) {
        if (newFlag != 0) {
          this.showAllGarden = 1
        } else {
          this.showAllGarden = 0
        }
        this.commit()
      }
    },
    methods: {
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      edit(row) {
        window.localStorage.setItem('yzappform', '')
         window.localStorage.setItem('yzappsaveData', '')
        // 将开始时间 结束时间转化为时间戳
        let d = new Date(row.beginTime)
        let dd = new Date(row.endTime)
        let beginTime = d.getTime(d)
        let endTime = dd.getTime(dd)
        row.beginTime = beginTime
        row.endTime = endTime
        this.$router.push({
          name: 'OwnerAppadvertisingadd',
          query: { id: row.id }
        })
      },
      onSubmit() {
        console.log('submit!')
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.topics()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.topics()
      },
      jumpToAdd() {
        window.localStorage.setItem('yzappform', '')
         window.localStorage.setItem('yzappsaveData', '')
        this.$router.push({
          name: 'OwnerAppadvertisingadd'
        })
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 小区下拉
      gardens() {
        let loading = this.$loading()
        this.$get(`/gardens`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 查询
      topics() {
        let loading = this.$loading()
        this.$get(
          `/doorDeviceNotice/?keyword=${this.keyword}&pageNo=${this.pageNum}&pageSize=${this.pageSize}&gardenId=${this.village}`
        ).then(
          res => {
            loading.close()
            
            if (res && res.errCode === 0) {
              this.advertisingList = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 查询按钮
      commit() {
        this.pageNum = 1
        this.topics()
      },
     // 杜，删除按钮
      deleteItem(res) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          })
          .then(() => {
            this.$delete(`/doorDeviceNotice/` + res.id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      }
    }
  }
</script>

<style lang="scss">

</style>